import { BlocksIconToolbox } from 'blocks-nextjs/blocks-web-components/components/icon/icons/toolbox';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconToolbox = createComponent({ react: React, tagName: 'cat-icon-toolbox', elementClass: BlocksIconToolbox });
